import { connect } from 'react-redux';
import { Route, Switch } from 'react-router';
import { Spin } from 'antd';
import { AppState } from '../../reducers';
import DefaultValueForm from './DefaultValueForm/DefaultValueForm';

function DefaultValue({ loading }: any) {
  return (
    <Spin spinning={loading}>
      <Switch>
        <Route exact path="/default_value/list" component={DefaultValueForm} />
      </Switch>
    </Spin>
  );
}

const mapStateToProps = (state: AppState) => ({
  loading: state.default_values.loading,
});

export default connect(mapStateToProps)(DefaultValue);
